<div class="selection-list" [formGroup]="group">
  <h3>{{ title }}</h3>
  @if (entitlementList) {
    @if (allEnabledSelected()) {
      <button mat-stroked-button type="button" (click)="deselectAll()">Deselect all</button>
    } @else {
      <button mat-stroked-button type="button" (click)="selectAllEnabled()">Select all</button>
    }

    <mat-selection-list [formControlName]="controlName" [multiple]="true">
      @for (entitlement of entitlementList; track entitlement.key) {
        <mat-list-option [value]="entitlement.key" [disabled]="entitlement.disabled">
          {{ entitlement.displayName }}
        </mat-list-option>
      }
    </mat-selection-list>
  }
</div>
